import React from 'react';

import Typography from 'components-new/typography/typography';

import { createLocale } from 'locales';

const localize = createLocale('freelancerPersonalInformationPageLocales');

const dialogInstructionsContent = (
  <>
    <Typography variant="heading-3" as="p" className="mb-3">
      {localize('dialogueInstructionHeadline')}
    </Typography>
    <Typography variant="body-medium" as="p" className="mb-3">
      {localize('dialogueInstructionParagraph1')}
    </Typography>
    <Typography variant="body-medium" as="p" className="mb-3">
      {localize('dialogueInstructionParagraph2')}
    </Typography>
    <Typography variant="body-medium" as="p" className="mb-3">
      {localize('dialogueInstructionParagraph3')}
    </Typography>
    <ul className="list-disc pl-10 mb-3">
      {(
        localize(
          'dialogueInstructionRequiredInformationList',
        ) as unknown as Array<string>
      ).map((element: string) => {
        return (
          <Typography variant="body-medium" as="li" key={element}>
            {element}
          </Typography>
        );
      })}
    </ul>
    <Typography variant="body-medium" as="p" className="mb-3">
      {localize('dialogueInstructionParagraph4')}
    </Typography>
    <Typography variant="body-medium" as="p" className="mb-3">
      {localize('dialogueInstructionParagraph5')}
    </Typography>
  </>
);

export default dialogInstructionsContent;
